import type { Paged } from '@/features/shared/domain/models/paged'
import { SoundEffectService } from '../../data/sound-effect.service'
import { mapAlgoliaPage } from '@/features/shared/domain/mappers/map-algolia-page'
import type { SoundEffect } from '../models/sound-effect'
import type { SoundEffectParameters } from '../models/sound-effect-parameters'
import { mapSoundEffectDtoToSoundEffect } from '../mappers/map-sound-effect-dto-to-sound-effect'
import type {
  SoundEffectFacets,
  SoundEffectDto,
} from '../../data/sound-effect.dto'
import { mapSoundEffectFacetsToSoundEffectFilters } from '../mappers/map-sound-effect-facets-to-sound-effect-filters'

export const fetchSoundEffects = async (
  page: number,
  filters: { tags: string[] },
  searchTerm?: string
): Promise<Paged<SoundEffect, SoundEffectParameters>> => {
  const PAGE_SIZE = 20
  const res = await SoundEffectService.getSoundEffects(
    page,
    PAGE_SIZE,
    searchTerm,
    filters
  )
  return mapAlgoliaPage<
    SoundEffectDto,
    SoundEffectFacets,
    SoundEffect,
    SoundEffectParameters
  >(
    mapSoundEffectDtoToSoundEffect,
    mapSoundEffectFacetsToSoundEffectFilters,
    res
  )
}
